import script from "./teachingLogDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./teachingLogDetail.vue?vue&type=script&setup=true&lang=js"

import "./teachingLogDetail.vue?vue&type=style&index=0&id=2673750a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2673750a"]])

export default __exports__